import API from '../../API';
import { showToast } from '../../Controllers/Toast';
import { AUTH, AUTH_FAIL, GET_BUSINESSEMAIL, GET_LOCATIONS, GET_STAFF, HANDLE_ERROR, LOGOUT, GET_CURRENCY, SET_LOCATIONS } from '../action.type';
import { persistor } from '../store';
export const handleLogin = (data) => {
    return async (dispatch) => {
        try {
            const userLogin = await API({ url: '/admin/pos/staff-login', method: 'post', data: { ...data } });
            if (userLogin?.status === 200 || userLogin?.status === 304) {
                dispatch({
                    type: AUTH,
                    payload: { ...userLogin?.data, is_loggedIn: true },
                });
                if(userLogin?.data?.pos_location?.length === 1) {
                    dispatch(selectLocation({ location_id: userLogin?.data?.pos_location[0] }))
                }
                showToast.success('Login Successfully!');
                localStorage.setItem('rememberme', true)
                localStorage.setItem('token', userLogin?.data?.token)
            }
        } catch (error) {
            showToast.error(error)
            dispatch({
                type: AUTH_FAIL,
                payload: error?.response?.data?.error,
            });
        }
    };
};
export const getBusinessEmail = () => {
    return async (dispatch) => {
        try {
            const apiCall = await API({ url: '/super/admin/tenant/getalltenantsname', method: 'get' })
            if (apiCall?.status === 200 || apiCall?.status === 304) {
                dispatch({
                    type: GET_BUSINESSEMAIL,
                    payload: apiCall?.data,
                });
            }
        } catch (error) {
            showToast.error(error)
            dispatch({
                type: HANDLE_ERROR,
                payload: error,
            });
        }
    };
};
export const getLocations = () => {
    return async (dispatch) => {
        try {
            const apiCall = await API({ url: '/admin/pos/getPOSLocations', method: 'get' })
            if (apiCall?.status === 200 || apiCall?.status === 304) {
                dispatch({
                    type: GET_LOCATIONS,
                    payload: apiCall?.data,
                });
            }
        } catch (error) {
            showToast.error(error)
            dispatch({
                type: HANDLE_ERROR,
                payload: error,
            });
        }
    };
};
export const selectLocation = (data) => {
    return async (dispatch) => {
        try {
            const apiCall = await API({ url: '/admin/pos/select-location', method: 'post', data: data })
            if (apiCall?.status === 200 || apiCall?.status === 304) {
                localStorage.setItem('token', apiCall?.data?.token)
                localStorage.setItem('location', apiCall?.data?.name)
                localStorage.setItem('location_id', apiCall?.data?._id)
                dispatch({
                    type: SET_LOCATIONS,
                    payload: apiCall?.data,
                });
                window.location.href = '/cashier'
            }
        } catch (error) {
            showToast.error(error)
            dispatch({
                type: HANDLE_ERROR,
                payload: error,
            });
        }
    };
};
export const getStaff = (id) => {
    return async (dispatch) => {
        try {
            const apiCall = await API({ url: `/admin/pos/getPOSstaff/${id}`, method: 'get', })
            if (apiCall?.status === 200 || apiCall?.status === 304) {
                dispatch({
                    type: GET_STAFF,
                    payload: apiCall?.data,
                });
            }
        } catch (error) {
            showToast.error(error)
            dispatch({
                type: HANDLE_ERROR,
                payload: error,
            });
        }
    };
};
export const getCurrencyRate = () => {
    return async (dispatch) => {
        try {
            const apiCall = await API({ url: `/admin/commondata/currencyrate`, method: 'get', })
            if (apiCall?.status === 200 || apiCall?.status === 304) {
                const currencyRate = await apiCall.data.currency_rate
                const ratesArray = Object.keys(currencyRate).map(key => {
                    return { name: key, rate: currencyRate[key] };
                }) ?? [];
                localStorage.setItem('currencyrate', JSON.stringify(ratesArray))
                dispatch({
                    type: GET_CURRENCY,
                    payload: ratesArray,
                });
            }
        } catch (error) {
            showToast.error(error)
            dispatch({
                type: HANDLE_ERROR,
                payload: error,
            });
        }
    };
};

export const logOut = () => {
    return async (dispatch) => {
        try {
            localStorage.removeItem('token');
            localStorage.removeItem('location');
            dispatch({
                type: LOGOUT,
            });
            persistor.purge();
            window.location.reload(true);
        } catch (error) {
            showToast.error(error)
            dispatch({
                type: HANDLE_ERROR,
                payload: error,
            });
        }
    };
};